import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

const defaultOptions = {
  redirectTo: `/login`
}

/*
 * Implementa HOC (high order component) para decorar un componente que
 * requiere autenticacion
 */

function requireAuth (WrappedComponent, options = defaultOptions) {
  const {
    redirectTo
  } = options

  const decoratedComponent = class extends Component {
    render () {
      const {
        authenticated
      } = this.props
      const component = authenticated
        ? <WrappedComponent {...this.props} />
        : <Redirect to={redirectTo} />
      return (<div>{component}</div>)
    }
  }

  const mapStateToProps = (state) => ({
    authenticated: state.auth.authenticated
  })

  return connect(mapStateToProps, null)(decoratedComponent)
};

export default requireAuth
